import React from 'react';
import '../styles/Skills.css';

function Skills() {
  const services = [
    {
      title: 'AI分野のコンサルティング',
      description: 'AIモデルを活用して業界特有の課題を解決するための提案、設計、導入支援を行っています。',
      details: 'AI分野のコンサルティングでは、業務プロセスの最適化から、AI導入後の効果測定まで包括的にサポートし、持続可能な価値を提供します。'
    },
    {
      title: 'PoCプロジェクト支援',
      description: 'アイデアを迅速に検証し、期待値と実際の成果との差を最小化するPoCプロジェクトの設計と実行を支援します。',
      details: 'PoCでは、データ収集やプロトタイプ開発から性能評価まで一貫して対応し、導入時の課題を事前に洗い出し、確実な実現可能性を提供します。'
    },
    {
      title: 'AIモデルの業務活用',
      description: '音声認識、コンピュータビジョン（CV）など、AI技術を活用して業務プロセスの効率化や新規サービスの構築を支援しています。',
      details: 'AIモデル活用では、モデルのトレーニングから業務フローへの適用までの一連のプロセスを設計し、課題解決や収益向上に貢献します。'
    },
    {
      title: 'LLMシステム開発',
      description: 'RAGやLLMOps、RAG評価システムを用いて、LLMを業務に適用するためのカスタムソリューションを提供します。',
      details: 'LLMシステム開発では、高度な自然言語処理技術を駆使し、検索性能の向上や効率的な運用基盤の構築をサポートします。'
    }
  ];
  

  return (
    <section id="skills" className="skills">
      <div className="skills-header">
        <h2>サービス</h2>
      </div>
      <div className="skills-container">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <div className="service-details">
              <p>{service.details}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
